(function ($) {

  const container = $(".animated-text-body");

  if (container.length == 0)
    return;

  $(window).on("scroll", function () {
    const rect = container[0].getBoundingClientRect();
    const windowHeight = $(window).height();

    // point de départ : bas de l’écran
    const start = windowHeight;
    // point de fin : milieu de l’écran (50%)
    const end = windowHeight / 2;

    // progress entre 0 et 1
    let progress = (start - rect.top) / (start - end);
    progress = Math.min(Math.max(progress, 0), 1);

    // applique le déplacement
    container.find(".left").css("transform", "translateX(" + (-100 + progress * 100) + "%)");
    container.find(".right").css("transform", "translateX(" + (100 - progress * 100) + "%)");
  })
})(jQuery);